import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { ContentContext } from "../../../contexts/contextExporter";
import { IAdminUnitMl } from "../adminTypes";
import { adminGetMlParts } from "../queries";
import clsx from "clsx";

export default function ItemMl({ ml }: { ml: IAdminUnitMl }) {
  const { pickedTree, setPickedTree } = useContext(ContentContext);

  const isPicked = pickedTree.mlId === ml.id;
  const { data: mlParts } = useQuery(
    adminGetMlParts({ mlId: ml.id, enabled: isPicked })
  );

  return (
    <div className="p-1 item-ml">
      <div
        onClick={() =>
          isPicked ? null : setPickedTree((prev) => ({ ...prev, mlId: ml.id, partId: null }))
        }
        className={clsx(
          "py-1 px-2 transition-all text-base",
          isPicked
            ? "bg-myOrange/50 rounded-t-lg text-white"
            : "cursor-pointer text-white/70 hover:text-white/90"
        )}
      >
        {ml.ml_title} <span className="text-white/50">(id: {ml.id})</span>
      </div>
      {mlParts && isPicked && (
        <div className="text-sm p-2 border-myOrange/50 border rounded-b-lg">
          {mlParts.map((part) => (
            <div
              key={part.id}
              className={clsx(
                part.id === pickedTree.partId
                  ? "text-myOrange"
                  : "text-white/70 hover:text-white/90 cursor-pointer"
              )}
              onClick={() =>
                setPickedTree((prev) => ({ ...prev, partId: part.id }))
              }
            >
              - {part.part_title} <span className="text-white/50">(id: {part.id})</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
